/*! Romanytas Size Advisor
 *  Height + weight rulers + fit -> one recommended size.
 *  Optional config: set window.ROMANYTAS_SIZE_ADVISOR = {...} BEFORE this script loads.
 */
(function () {
  'use strict';
  if (window.__romanytasSizeAdvisorLoaded) return;
  window.__romanytasSizeAdvisorLoaded = true;

  var doc = document;

  /* ------------------------------------------------------------------ *
   * Config
   * ------------------------------------------------------------------ */
  var DEFAULTS = {
    // ---- Base rules = the standard tee. Other products override them via `profiles` below. ----
    // Size scale, smallest -> largest.
    scale: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    // Upper weight limit (kg) of each size in `scale`, INCLUSIVE. Same order as `scale`.
    //   XS: 0 (never recommended)  S: up to 74  M: up to 83  L: up to 92  XL: up to 100  XXL: 101+
    bands: [0, 74, 83, 92, 100, 999],
    // The top N kg of each size (except the last) also show the "between two sizes" note.
    alertKg: 2,
    // Heights (cm) at which one size is added. [190] => +1 from 190 cm. [185, 195] => +1 from 185, +2 from 195.
    heightShifts: [190],
    // The N cm just below each height shift also show the "between two sizes" note (2 => 188-189 cm).
    heightAlertCm: 2,
    // Third input (shoulders / chest). It never shifts a whole size: it only decides the direction
    // when the customer is between two sizes. `upFit` = the answer that goes to the LARGER size.
    fitKeys: ['narrow', 'regular', 'wide'],
    upFit: 'wide',
    defaults: { height: 175, weight: 70, fit: 'regular' },
    units: { height: 'cm', weight: 'kg' },
    ranges: { cm: [140, 210], ft: [55, 83], kg: [40, 150], lb: [88, 330] }, // ft = inches
    sizeOffset: 0,               // product-level shift, e.g. -1 for a style that runs large
    sizes: [],                   // product sizes; usually supplied by the Liquid snippet
    selectButton: true,          // show "Choose size X" that picks the variant on the page
    sizeGuideSelector: '[data-size-guide], .size-guide-link, a[href*="size-guide"], a[href*="guida-alle-taglie"]',
    sizeGuideUrl: '',
    autoInject: true,            // add the button if the theme doesn't render one
    anchorSelector: '',          // optional: insert the auto button before this element
    dedupe: true,
    profile: 'default',          // used when the button has no data-rsa-profile
    // Per-product-type overrides. Anything not listed falls back to the base rules above.
    profiles: {
      hoodie: {
        scale: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
        //        XS  S   M   L   XL   XXL
        bands: [58, 72, 84, 96, 105, 999],   // XS up to 58 | S 59-72 | M 73-84 | L 85-96 | XL 97-105 | XXL 106+
        alertKg: 2,                          // between zones: 57-58, 71-72, 83-84, 95-96, 104-105
        heightShifts: [185, 195],            // +1 from 185 cm, +2 from 195 cm
        heightAlertCm: 2,                    // between zones: 183-184, 193-194
        defaults: { height: 175, weight: 70, fit: 'regular' }
        // third input = shoulders (same as the tee)
      },
      'baby-tee': {
        scale: ['S', 'M', 'L', 'XL'],
        //        S   M   L   XL
        bands: [52, 59, 67, 999],            // S up to 52 | M 53-59 | L 60-67 | XL 68+
        alertKg: 2,                          // between zones: 51-52, 58-59, 66-67
        heightShifts: [176],                 // +1 from 176 cm (to be confirmed with real fits)
        heightAlertCm: 2,                    // between zone: 174-175
        defaults: { height: 160, weight: 50, fit: 'medium' },
        // third input = chest. It never lowers a size: only "grande" goes up, in the between zones.
        fitKeys: ['small', 'medium', 'large'],
        upFit: 'large',
        text: {
          fit: 'Dimensione seno',
          fits: { small: 'Piccola', medium: 'Media', large: 'Grande' },
          notes: {
            small: 'Sei a metà tra due taglie: se preferisci una vestibilità meno aderente, scegli quella sopra.',
            medium: 'Sei a metà tra due taglie: se preferisci una vestibilità meno aderente, scegli quella sopra.',
            large: 'Sei a metà tra due taglie: per la dimensione del seno è stata suggerita la più grande.'
          }
        }
      }
    },
    text: {
      trigger: 'Trova la mia taglia',
      title: 'Trova la tua taglia',
      close: 'Chiudi',
      height: 'Quanto sei alto?',
      weight: 'Quanto pesi?',
      fit: 'Larghezza spalle',
      fits: { narrow: 'Strette', regular: 'Medie', wide: 'Larghe' },
      result: 'La tua taglia',
      basis: 'Stima per {height}, {weight} e vestibilità {fit}.',
      // "Between two sizes" note, by the answer to the third question (key = fit value).
      notes: {
        narrow: 'Sei a metà tra due taglie: è stata suggerita la più piccola perché il prodotto ha una vestibilità oversize.',
        regular: 'Sei a metà tra due taglie: è stata suggerita la più piccola perché il prodotto ha una vestibilità oversize.',
        wide: 'Sei a metà tra due taglie: per la larghezza spalle è stata suggerita quella più grande.'
      },
      disclaimer: 'Stima indicativa basata sulle misure inserite: può variare in base alla tua corporatura.',
      pick: 'Aggiungi al carrello',
      adding: 'Aggiungo…',
      error: 'Non siamo riusciti ad aggiungere la taglia al carrello. Selezionala manualmente.',
      unavailable: 'La taglia {size} non è al momento disponibile.',
      guide: 'Guida alle taglie',
      units: { cm: 'cm', ft: 'ft', kg: 'kg', lb: 'lbs' }
    }
  };

  function isObj(o) { return o && typeof o === 'object' && !Array.isArray(o); }
  function extend(base, over) {
    var out = {}, k;
    for (k in base) out[k] = isObj(base[k]) ? extend(base[k], {}) : base[k];
    for (k in over) out[k] = isObj(over[k]) && isObj(out[k]) ? extend(out[k], over[k]) : over[k];
    return out;
  }
  var cfg = extend(DEFAULTS, window.ROMANYTAS_SIZE_ADVISOR || {});
  var T = cfg.text;

  // Base rules + the chosen profile's overrides.
  function resolveProfile(name) {
    var over = (cfg.profiles && cfg.profiles[name]) || {}, base = {}, k;
    for (k in cfg) { if (k !== 'profiles' && k !== 'text') base[k] = cfg[k]; }
    var p = extend(base, over);
    p.name = cfg.profiles && cfg.profiles[name] ? name : 'default';
    p.text = extend(cfg.text, over.text || {});
    return p;
  }

  /* ------------------------------------------------------------------ *
   * Helpers
   * ------------------------------------------------------------------ */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function h(tag, cls) { var e = doc.createElement(tag); if (cls) e.className = cls; return e; }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var X_SVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ------------------------------------------------------------------ *
   * Units. The state always stores metric values (cm / kg).
   * ------------------------------------------------------------------ */
  function ftIn(v) { return Math.floor(v / 12) + "'" + (v % 12) + '"'; }
  var UNITS = {
    cm: { min: cfg.ranges.cm[0], max: cfg.ranges.cm[1], step: 10, major: 10, mid: 5,
      label: String, fmt: function (v) { return v + ' cm'; },
      toMetric: function (v) { return v; }, fromMetric: function (m) { return Math.round(m); } },
    ft: { min: cfg.ranges.ft[0], max: cfg.ranges.ft[1], step: 14, major: 6, mid: 3,
      label: ftIn, fmt: ftIn,
      toMetric: function (v) { return v * 2.54; }, fromMetric: function (m) { return Math.round(m / 2.54); } },
    kg: { min: cfg.ranges.kg[0], max: cfg.ranges.kg[1], step: 10, major: 10, mid: 5,
      label: String, fmt: function (v) { return v + ' kg'; },
      toMetric: function (v) { return v; }, fromMetric: function (m) { return Math.round(m); } },
    lb: { min: cfg.ranges.lb[0], max: cfg.ranges.lb[1], step: 8, major: 10, mid: 5,
      label: String, fmt: function (v) { return v + ' lb'; },
      toMetric: function (v) { return v * 0.45359237; }, fromMetric: function (m) { return Math.round(m / 0.45359237); } }
  };

  /* ------------------------------------------------------------------ *
   * Size logic
   * ------------------------------------------------------------------ */
  var ALIAS = { '2XL': 'XXL', XXLARGE: 'XXL', SMALL: 'S', MEDIUM: 'M', LARGE: 'L', XLARGE: 'XL', EXTRALARGE: 'XL', EXTRASMALL: 'XS' };
  function canon(s) {
    s = String(s).toUpperCase().replace(/[\s\-_.]/g, '');
    return ALIAS[s] || s;
  }

  // Product sizes -> [{i: index in scale, canon, label: original Shopify value}]
  function buildCtx(sizes, offset, prof) {
    prof = prof || resolveProfile('default');
    var avail = [], seen = {};
    (sizes || []).forEach(function (s) {
      var c = canon(s), i = prof.scale.indexOf(c);
      if (i >= 0 && !seen[c]) { seen[c] = 1; avail.push({ i: i, canon: c, label: String(s) }); }
    });
    avail.sort(function (a, b) { return a.i - b.i; });
    return { avail: avail, offset: +offset || 0, prof: prof };
  }

  // Index in `scale` -> the product's nearest real size (clamped; tie -> smaller).
  function toProduct(i, ctx) {
    var scale = ctx.prof.scale;
    i = clamp(i, 0, scale.length - 1);
    var label = scale[i], canonSize = scale[i];
    if (ctx.avail.length) {
      var best = null;
      ctx.avail.forEach(function (a) {
        var d = Math.abs(a.i - i);
        if (!best || d < best.d || (d === best.d && a.i < best.a.i)) best = { a: a, d: d };
      });
      label = best.a.label; canonSize = best.a.canon;
    }
    return { canon: canonSize, label: label };
  }

  function recommend(hCm, wKg, fit, ctx) {
    var P = ctx.prof, bands = P.bands, shifts = P.heightShifts || [], k;
    hCm = Math.round(hCm); wKg = Math.round(wKg);

    // 1. Base size from weight (limits are inclusive).
    var i = bands.length - 1;
    for (k = 0; k < bands.length; k++) { if (wKg <= bands[k]) { i = k; break; } }

    // 2. Height shifts, and just below each shift the "between two sizes" zone.
    var between = false;
    for (k = 0; k < shifts.length; k++) {
      if (hCm >= shifts[k]) i++;
      else if (hCm >= shifts[k] - P.heightAlertCm) between = true;
    }
    i += (ctx.offset || 0);

    // 3. Top of a weight band = between two sizes.
    for (k = 0; k < bands.length - 1; k++) { if (wKg > bands[k] - P.alertKg && wKg <= bands[k]) between = true; }

    // 4. Between two sizes: the third input can only push UP (upFit -> larger); everything else -> smaller.
    var low = toProduct(i, ctx), high = toProduct(i + 1, ctx);
    if (between && low.canon !== high.canon) {
      var pick = fit === P.upFit ? high : low;
      return { canon: pick.canon, label: pick.label, onBoundary: true };
    }
    return { canon: low.canon, label: low.label, onBoundary: false };
  }

  /* ------------------------------------------------------------------ *
   * Ruler: the list scrolls, a fixed needle marks the value.
   * ------------------------------------------------------------------ */
  function createRuler(u, ariaLabel, value, onInput) {
    var n = u.max - u.min + 1, step = u.step;
    var current = clamp(value - u.min, 0, n - 1);
    var timer = 0, dragging = false, touching = false, moved = false, suppressClick = false;
    var startX = 0, startLeft = 0, lastW = -1, ro = null;

    var wrap = h('div', 'rsa-rulerwrap');
    var ul = h('ul', 'rsa-ruler');
    ul.tabIndex = 0;
    ul.setAttribute('role', 'slider');
    ul.setAttribute('aria-label', ariaLabel);
    ul.setAttribute('aria-valuemin', u.min);
    ul.setAttribute('aria-valuemax', u.max);

    var frag = doc.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var v = u.min + i;
      var isMajor = v % u.major === 0;
      var li = h('li', 'rsa-tick' + (isMajor ? ' rsa-tick--major' : v % u.mid === 0 ? ' rsa-tick--mid' : ''));
      li.setAttribute('data-i', i);
      li.style.width = step + 'px';
      if (isMajor) { var s = h('span', 'rsa-ticklabel'); s.textContent = u.label(v); li.appendChild(s); }
      frag.appendChild(li);
    }
    var spacer = h('li', 'rsa-spacer');
    frag.appendChild(spacer);
    ul.appendChild(frag);

    var needle = h('div', 'rsa-needle');
    needle.setAttribute('aria-hidden', 'true');
    wrap.appendChild(ul);
    wrap.appendChild(needle);

    function announce() {
      ul.setAttribute('aria-valuenow', u.min + current);
      ul.setAttribute('aria-valuetext', u.fmt(u.min + current));
    }
    announce();

    // Needs a real width: call only after the modal is attached to the document.
    function layout() {
      var w = ul.clientWidth;
      if (!w) return false;
      var pad = Math.max(0, Math.round(w / 2 - step / 2));
      ul.style.paddingLeft = pad + 'px';
      ul.style.paddingRight = '0px';
      spacer.style.flex = '0 0 ' + pad + 'px';
      spacer.style.width = pad + 'px';
      ul.scrollLeft = current * step;
      lastW = w;
      return true;
    }

    function settle() {
      if (dragging || touching) return;
      var target = current * step;
      if (Math.abs(ul.scrollLeft - target) > 1) ul.scrollTo({ left: target, behavior: 'smooth' });
    }

    ul.addEventListener('scroll', function () {
      var i = clamp(Math.round(ul.scrollLeft / step), 0, n - 1);
      if (i !== current) { current = i; announce(); onInput(u.min + i); }
      clearTimeout(timer);
      timer = setTimeout(settle, 90);
    }, { passive: true });

    // Touch: native scrolling, then snap once it stops.
    ul.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    function touchEnd() { touching = false; clearTimeout(timer); timer = setTimeout(settle, 90); }
    ul.addEventListener('touchend', touchEnd, { passive: true });
    ul.addEventListener('touchcancel', touchEnd, { passive: true });

    // Mouse: grab and drag.
    function onMove(e) {
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      ul.scrollLeft = startLeft - dx;
    }
    function onUp() {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      dragging = false;
      ul.classList.remove('is-dragging');
      suppressClick = moved;
      setTimeout(function () { suppressClick = false; }, 30);
      settle();
    }
    ul.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; moved = false; startX = e.clientX; startLeft = ul.scrollLeft;
      ul.classList.add('is-dragging');
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
    });

    // Click / tap a tick: glide it under the needle.
    ul.addEventListener('click', function (e) {
      if (suppressClick) { suppressClick = false; return; }
      var li = e.target.closest ? e.target.closest('.rsa-tick') : null;
      if (li) ul.scrollTo({ left: (+li.getAttribute('data-i')) * step, behavior: 'smooth' });
    });

    ul.addEventListener('keydown', function (e) {
      var d = { ArrowLeft: -1, ArrowDown: -1, ArrowRight: 1, ArrowUp: 1, PageDown: -10, PageUp: 10 }[e.key], t;
      if (d) t = current + d; else if (e.key === 'Home') t = 0; else if (e.key === 'End') t = n - 1; else return;
      e.preventDefault();
      ul.scrollTo({ left: clamp(t, 0, n - 1) * step, behavior: 'auto' });
    });

    if (window.ResizeObserver) {
      ro = new ResizeObserver(function () { if (ul.clientWidth !== lastW) layout(); });
      ro.observe(ul);
    }

    return {
      el: wrap,
      layout: layout,
      destroy: function () { clearTimeout(timer); if (ro) ro.disconnect(); }
    };
  }

  /* ------------------------------------------------------------------ *
   * Product data (sizes) — from the trigger's data attributes, else the page
   * ------------------------------------------------------------------ */
  // Some themes put an option-value ID in value="" — then fall back to the visible label.
  function optName(el) {
    var v = el.value;
    if (v && !/^\d+$/.test(v)) return v;
    var t = (el.labels && el.labels[0] ? el.labels[0].textContent : '') ||
      el.getAttribute('aria-label') || el.getAttribute('data-value') || el.text || v || '';
    return String(t).replace(/\s+/g, ' ').trim();
  }

  function sizesFromDom() {
    var out = [], seen = {};
    var nodes = doc.querySelectorAll(
      'input[type="radio"][name*="size" i], input[type="radio"][name*="taglia" i], ' +
      'select[name*="size" i] option, select[name*="taglia" i] option');
    for (var i = 0; i < nodes.length; i++) {
      var v = optName(nodes[i]);
      if (v && !seen[v]) { seen[v] = 1; out.push(v); }
    }
    return out;
  }

  function productDataFor(trigger) {
    var sizes = null, offset = cfg.sizeOffset, profile = cfg.profile, preview = false;
    if (trigger) {
      try { sizes = JSON.parse(trigger.getAttribute('data-rsa-sizes') || 'null'); } catch (e) { sizes = null; }
      var o = trigger.getAttribute('data-rsa-offset');
      if (o !== null && o !== '') offset = +o || 0;
      var pr = trigger.getAttribute('data-rsa-profile');
      if (pr) profile = pr;
      preview = trigger.getAttribute('data-rsa-preview') === 'true';
    }
    if (!sizes || !sizes.length) sizes = cfg.sizes && cfg.sizes.length ? cfg.sizes : sizesFromDom();
    return { sizes: sizes, offset: offset, profile: profile, preview: preview };
  }

  /* ------------------------------------------------------------------ *
   * Select the size in the theme, then add it to the cart (best effort)
   * ------------------------------------------------------------------ */
  // Never touch pickers/forms that belong to product cards, quick-add or dialogs.
  var OUTSIDE = 'product-card, quick-add-component, dialog, .rsa-modal';

  function findSizeControl(label) {
    var roots = Array.prototype.slice.call(doc.querySelectorAll('variant-picker[data-template-product-match="true"]'));
    roots.push(doc);
    for (var k = 0; k < roots.length; k++) {
      var radios = roots[k].querySelectorAll('input[type="radio"]'), i, j, r;
      for (var pass = 0; pass < 2; pass++) {
        for (i = 0; i < radios.length; i++) {
          r = radios[i];
          if (r.closest(OUTSIDE) || optName(r) !== label) continue;
          if (pass === 0 && !/size|taglia/i.test(r.name || '')) continue;
          return { el: r, radio: true };
        }
      }
      var selects = roots[k].querySelectorAll('select');
      for (i = 0; i < selects.length; i++) {
        if (selects[i].closest(OUTSIDE) || !/size|taglia/i.test(selects[i].name || '')) continue;
        for (j = 0; j < selects[i].options.length; j++) {
          if (optName(selects[i].options[j]) === label) return { el: selects[i], index: j };
        }
      }
    }
    return null;
  }

  function isSelected(c) { return c.radio ? c.el.checked : c.el.selectedIndex === c.index; }

  function applySelection(c) {
    if (c.radio) {
      c.el.click();
      if (!c.el.checked) {
        c.el.checked = true;
        c.el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      c.el.selectedIndex = c.index;
      c.el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function findProductForm() {
    var forms = doc.querySelectorAll('product-form-component form, form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].closest(OUTSIDE) && forms[i].querySelector('[name="id"]')) return forms[i];
    }
    return null;
  }

  // Horizon re-renders the picker and updates the hidden variant id asynchronously.
  function waitForVariant(idEl, prevId, cb) {
    var done = false, iv, to;
    function finish() {
      if (done) return;
      done = true;
      doc.removeEventListener('variant:update', finish);
      clearInterval(iv); clearTimeout(to);
      setTimeout(cb, 80);
    }
    doc.addEventListener('variant:update', finish);
    iv = setInterval(function () { if (idEl && idEl.value !== prevId) finish(); }, 80);
    to = setTimeout(finish, 3500);
  }

  // cb(err, addButton): err is 'error' or 'unavailable'
  function selectSizeThenFindButton(label, cb) {
    var ctrl = findSizeControl(label), form = findProductForm();
    if (!ctrl || !form) return cb('error');
    var idEl = form.querySelector('[name="id"]'), prev = idEl ? idEl.value : '';
    function go() {
      var btn = form.querySelector('button[name="add"], [ref="addToCartButton"], button[type="submit"]');
      if (!btn) return cb('error');
      if (btn.disabled) return cb('unavailable');
      cb(null, btn);
    }
    if (isSelected(ctrl)) return go();
    applySelection(ctrl);
    waitForVariant(idEl, prev, go);
  }

  /* ------------------------------------------------------------------ *
   * Modal
   * ------------------------------------------------------------------ */
  var previewOnly = false, ui = null, state = null, ctx = null, lastTrigger = null, last = null;

  function unitBtns(kind, keys) {
    return keys.map(function (k) {
      return '<button type="button" class="rsa-unit" data-unit="' + kind + ':' + k + '" aria-pressed="' +
        (state[kind].unit === k) + '">' + esc(T.units[k]) + '</button>';
    }).join('');
  }

  function fieldHtml(kind, keys) {
    return '<div class="rsa-field" data-field="' + kind + '">' +
      '<div class="rsa-field-top"><p class="rsa-label">' + esc(T[kind]) + '</p>' +
      '<div class="rsa-units" role="group" aria-label="' + esc(T[kind]) + '">' + unitBtns(kind, keys) + '</div></div>' +
      '<div class="rsa-valuewrap"><div class="rsa-value" data-value="' + kind + '"></div></div>' +
      '<div data-slot="' + kind + '"></div></div>';
  }

  function open(trigger) {
    if (ui) return;
    lastTrigger = trigger || null;
    var pd = productDataFor(trigger);
    var P = resolveProfile(pd.profile);
    T = P.text;
    ctx = buildCtx(pd.sizes, pd.offset, P);
    previewOnly = pd.preview;
    state = {
      fit: P.defaults.fit,
      height: { unit: cfg.units.height, metric: P.defaults.height, ruler: null },
      weight: { unit: cfg.units.weight, metric: P.defaults.weight, ruler: null }
    };

    var root = h('div', 'rsa-modal');
    root.innerHTML =
      '<div class="rsa-panel" role="dialog" aria-modal="true" aria-labelledby="rsa-title" tabindex="-1">' +
        '<div class="rsa-head"><h2 class="rsa-title" id="rsa-title">' + esc(T.title) + '</h2>' +
        '<button type="button" class="rsa-close" data-rsa-close aria-label="' + esc(T.close) + '">' + X_SVG + '</button></div>' +
        '<div class="rsa-body">' +
          fieldHtml('height', ['cm', 'ft']) +
          fieldHtml('weight', ['kg', 'lb']) +
          '<div class="rsa-field"><p class="rsa-label rsa-label--muted">' + esc(T.fit) + '</p>' +
            '<div class="rsa-fits">' +
            P.fitKeys.map(function (f) {
              return '<button type="button" class="rsa-fit" data-fit="' + f + '" aria-pressed="' + (state.fit === f) + '">' + esc(T.fits[f]) + '</button>';
            }).join('') + '</div></div>' +
          '<section class="rsa-result">' +
            '<p class="rsa-label rsa-label--muted">' + esc(T.result) + '</p>' +
            '<p class="rsa-size" data-rsa-size></p>' +
            '<p class="rsa-between" data-rsa-between hidden></p>' +
            '<p class="rsa-disclaimer">' + esc(T.disclaimer) + '</p>' +
          '</section>' +
          '<div class="rsa-actions">' +
            '<p class="rsa-error" data-rsa-error role="alert" hidden></p>' +
            '<button type="button" class="rsa-pick" data-rsa-pick hidden></button>' +
            '<button type="button" class="rsa-guide-btn" data-rsa-guide hidden>' + esc(T.guide) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    ui = {
      root: root,
      panel: root.querySelector('.rsa-panel'),
      size: root.querySelector('[data-rsa-size]'),
      between: root.querySelector('[data-rsa-between]'),
      error: root.querySelector('[data-rsa-error]'),
      pick: root.querySelector('[data-rsa-pick]'),
      guide: root.querySelector('[data-rsa-guide]')
    };

    // Attach FIRST: an element that isn't in the page has no width, so the rulers couldn't centre.
    doc.body.appendChild(root);
    doc.documentElement.classList.add('rsa-lock');

    mountRuler('height');
    mountRuler('weight');
    updateResult();

    if (cfg.selectButton && ctx.avail.length && !previewOnly) ui.pick.hidden = false;
    if (cfg.sizeGuideUrl || findGuide()) ui.guide.hidden = false;

    root.addEventListener('click', onClick);
    doc.addEventListener('keydown', onKey);

    void root.offsetWidth;
    requestAnimationFrame(function () {
      if (!ui) return;
      root.classList.add('is-open');
      ui.panel.focus({ preventScroll: true });
      // Second pass once the layout has fully settled.
      ['height', 'weight'].forEach(function (k) { state[k].ruler && state[k].ruler.layout(); });
    });
  }

  function mountRuler(kind) {
    var f = state[kind], u = UNITS[f.unit];
    var disp = clamp(u.fromMetric(f.metric), u.min, u.max);
    if (f.ruler) f.ruler.destroy();
    var slot = ui.root.querySelector('[data-slot="' + kind + '"]');
    slot.innerHTML = '';
    f.ruler = createRuler(u, T[kind], disp, function (v) {
      f.metric = u.toMetric(v);
      updateValue(kind, v);
      updateResult();   // only text updates — the ruler DOM is never rebuilt while dragging
    });
    slot.appendChild(f.ruler.el);
    f.ruler.layout();
    requestAnimationFrame(function () { if (ui && f.ruler) f.ruler.layout(); });
    updateValue(kind, disp);
  }

  function updateValue(kind, v) {
    ui.root.querySelector('[data-value="' + kind + '"]').textContent = UNITS[state[kind].unit].fmt(v);
  }

  function displayOf(kind) {
    var u = UNITS[state[kind].unit];
    return u.fmt(clamp(u.fromMetric(state[kind].metric), u.min, u.max));
  }

  function fit_note(fit) {
    return (T.notes && (T.notes[fit] || T.notes.regular)) || '';
  }

  function updateResult() {
    last = recommend(state.height.metric, state.weight.metric, state.fit, ctx);
    ui.size.textContent = last.canon;
    ui.between.textContent = fit_note(state.fit);
    ui.between.hidden = !last.onBoundary;
    ui.pick.textContent = T.pick.replace('{size}', last.canon);
  }

  function changeUnit(kind, unit) {
    if (state[kind].unit === unit) return;
    state[kind].unit = unit;
    var btns = ui.root.querySelectorAll('[data-unit^="' + kind + ':"]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-unit') === kind + ':' + unit);
    }
    mountRuler(kind);
    updateResult();
  }

  function setFit(fit) {
    state.fit = fit;
    var btns = ui.root.querySelectorAll('[data-fit]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-fit') === fit);
    }
    updateResult();
  }

  var busy = false;
  function addPicked(btn) {
    if (!last || busy) return;
    busy = true;
    var m = ui, size = last.label, canonSize = last.canon;
    btn.disabled = true;
    btn.textContent = T.adding;
    m.error.hidden = true;
    selectSizeThenFindButton(size, function (err, addBtn) {
      busy = false;
      if (ui !== m) return;               // modal was closed meanwhile: don't add behind the customer's back
      if (err) {
        btn.disabled = false;
        btn.textContent = T.pick.replace('{size}', canonSize);
        m.error.textContent = err === 'unavailable' ? T.unavailable.replace('{size}', canonSize) : T.error;
        m.error.hidden = false;
        return;
      }
      close();
      addBtn.click();                     // the theme's own add-to-cart: cart drawer, count and animation all update
    });
  }

  function findGuide() {
    if (!cfg.sizeGuideSelector) return null;
    var list = doc.querySelectorAll(cfg.sizeGuideSelector);
    for (var i = 0; i < list.length; i++) { if (!list[i].closest('.rsa-modal') && !list[i].hasAttribute('data-rsa-trigger')) return list[i]; }
    return null;
  }

  function onClick(e) {
    if (e.target === ui.root) return close();
    var b = e.target.closest ? e.target.closest('button') : null;
    if (!b) return;
    if (b.hasAttribute('data-rsa-close')) close();
    else if (b.hasAttribute('data-unit')) { var p = b.getAttribute('data-unit').split(':'); changeUnit(p[0], p[1]); }
    else if (b.hasAttribute('data-fit')) setFit(b.getAttribute('data-fit'));
    else if (b.hasAttribute('data-rsa-pick')) addPicked(b);
    else if (b.hasAttribute('data-rsa-guide')) {
      var g = findGuide(), url = cfg.sizeGuideUrl;
      close();
      setTimeout(function () { if (g) g.click(); else if (url) window.location.href = url; }, 300);
    }
  }

  function onKey(e) {
    if (!ui) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(
      ui.root.querySelectorAll('button, [tabindex="0"]'),
      function (el) { return el.getClientRects().length > 0; });
    if (!items.length) return;
    var first = items[0], lastEl = items[items.length - 1];
    if (e.shiftKey && (doc.activeElement === first || doc.activeElement === ui.panel)) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && doc.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  }

  function close() {
    if (!ui) return;
    var m = ui, s = state;
    ui = null; state = null;
    m.root.classList.remove('is-open');
    doc.removeEventListener('keydown', onKey);
    doc.documentElement.classList.remove('rsa-lock');
    setTimeout(function () {
      ['height', 'weight'].forEach(function (k) { s[k].ruler && s[k].ruler.destroy(); });
      if (m.root.parentNode) m.root.parentNode.removeChild(m.root);
    }, 260);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  /* ------------------------------------------------------------------ *
   * Trigger button — delegated clicks survive Shopify re-rendering the variant picker
   * ------------------------------------------------------------------ */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-rsa-trigger]') : null;
    if (t) { e.preventDefault(); open(t); }
  });

  var knownData = null;
  function buildButton() {
    var b = h('button', 'rsa-btn');
    b.type = 'button';
    b.setAttribute('data-rsa-trigger', '');
    if (knownData) {
      b.setAttribute('data-rsa-sizes', JSON.stringify(knownData.sizes));
      b.setAttribute('data-rsa-offset', knownData.offset);
      if (knownData.profile) b.setAttribute('data-rsa-profile', knownData.profile);
    }
    b.innerHTML = '<span>' + esc(T.trigger) + '</span>';
    return b;
  }

  function findAnchor() {
    if (cfg.anchorSelector) return doc.querySelector(cfg.anchorSelector);
    var el = doc.querySelector(
      'input[name*="size" i], input[name*="taglia" i], select[name*="size" i], select[name*="taglia" i], ' +
      '[data-option-name*="size" i], [data-option-name*="taglia" i]');
    if (el) return el.closest('fieldset, .product-form__input, .selector-wrapper, .variant-picker__option, [class*="option"]') || el.parentElement;
    return null;
  }

  function ensureTrigger() {
    var triggers = doc.querySelectorAll('[data-rsa-trigger]');
    if (triggers.length) {
      if (!knownData && triggers[0].getAttribute('data-rsa-sizes')) knownData = productDataFor(triggers[0]);
      if (cfg.dedupe) for (var i = 1; i < triggers.length; i++) triggers[i].parentNode.removeChild(triggers[i]);
      return;
    }
    if (!cfg.autoInject || !/\/products\//.test(window.location.pathname)) return;
    var anchor = findAnchor();
    if (!anchor || !anchor.parentNode) return;
    if (!knownData) knownData = productDataFor(null);
    if (!knownData.sizes.length) return;
    anchor.parentNode.insertBefore(buildButton(), anchor);
  }

  function init() {
    ensureTrigger();
    if (!window.MutationObserver) return;
    var raf = 0;
    new MutationObserver(function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; ensureTrigger(); });
    }).observe(doc.body, { childList: true, subtree: true });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();

  /* Console / debugging API */
  window.RomanytasSizeAdvisor = {
    open: function () { open(doc.querySelector('[data-rsa-trigger]')); },
    close: close,
    // e.g. RomanytasSizeAdvisor.recommend(180, 83, 'regular', ['XS','S','M','L','XL','XXL'], 0, 'hoodie')
    recommend: function (heightCm, weightKg, fit, sizes, offset, profile) {
      var P = resolveProfile(profile || cfg.profile);
      return recommend(heightCm, weightKg, fit || P.defaults.fit, buildCtx(sizes, offset, P));
    }
  };
})();